// extracted by mini-css-extract-plugin
export default {"notification":"setup-page-footer_notification__kYPw5","fadeOut":"setup-page-footer_fadeOut__F24a7","staticButton":"setup-page-footer_staticButton__mkw-q"};